import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import LoadingSkeleton from '../components/LoadingSkeleton';
import Contact from './Contact';
import Education from './Education';
import Me from './Me';
import Projects from './Projects';
import Work from './Work';

// The PDF renderer is heavy, so it's only loaded when /resume is opened.
const Resume = lazy(() => import('./Resume'));

const Pages = ({ user }) => {
  return (
    <Router>
      <Suspense fallback={<LoadingSkeleton />}>
        <Routes>
          <Route path="/" element={<Me user={user} />} />
          <Route path="/projects" element={<Projects user={user} />} />
          <Route path="/work" element={<Work user={user} />} />
          <Route path="/education" element={<Education user={user} />} />
          <Route path="/contact" element={<Contact user={user} />} />
          <Route path="/resume" element={<Resume user={user} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default Pages;
